// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3xJ_8","col":"styles_col__2Djlt"};